import { render, staticRenderFns } from "./d-search-tags.vue?vue&type=template&id=a6f9e008&scoped=true&"
import script from "./d-search-tags.vue?vue&type=script&lang=js&"
export * from "./d-search-tags.vue?vue&type=script&lang=js&"
import style0 from "./d-search-tags.vue?vue&type=style&index=0&id=a6f9e008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f9e008",
  null
  
)

export default component.exports